<nav class="top-0 z-50 bg-white border-b border-gray-100 relative">

  <div class="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">

    <!-- Brand -->
    <div class="cursor-pointer" routerLink="">
      <img src="assets/logo.jpeg" alt="AuditFixers Logo" class="h-16 md:h-20 w-auto" />
    </div>

    <!-- Desktop Menu -->
    <div class="hidden md:flex items-center gap-10 text-base">
      <a routerLink="/" class="px-3 py-2 rounded-lg text-gray-800 hover:bg-blue-50 hover:text-blue-600 transition">
        Home
      </a>

      <a routerLink="/who-we-are" routerLinkActive="text-blue-600 font-semibold" class="px-3 py-2 rounded-lg text-gray-800 hover:bg-blue-50 hover:text-blue-600 transition">
        About Us
      </a>

      <a routerLink="/pricing" routerLinkActive="text-blue-600 font-semibold" class="px-3 py-2 rounded-lg text-gray-800 hover:bg-blue-50 hover:text-blue-600 transition">
        Pricing
      </a>

      <a routerLink="/contact-us" class="px-3 py-2 rounded-lg text-gray-800 hover:bg-blue-50 hover:text-blue-600 transition">
        Contact Us
      </a>
    </div>

    <!-- CTA Desktop -->
    <div class="hidden md:block">
      <button
        type="button"
        class="bg-blue-600 text-white px-6 py-3 text-base font-medium rounded-xl hover:bg-blue-700 transition shadow-md"
        routerLink="/gap-check/intro"
      >
        Get Free Gap Check
      </button>
    </div>

    <!-- Burger -->
    <button
      type="button"
      class="md:hidden flex flex-col justify-center items-center w-10 h-10"
      (click)="toggleMenu()"
      aria-label="Open menu"
    >
      <span class="w-6 h-0.5 bg-gray-800 mb-1"></span>
      <span class="w-6 h-0.5 bg-gray-800 mb-1"></span>
      <span class="w-6 h-0.5 bg-gray-800"></span>
    </button>

  </div>

  <!-- FULLSCREEN MOBILE MENU -->
  @if (menuOpen) {
    <div class="fixed inset-0 z-50 flex items-center justify-center">

      <!-- ACCESSIBLE OVERLAY -->
      <button
        type="button"
        class="absolute inset-0 bg-blue-900/20 backdrop-blur-xl"
        (click)="closeMenu()"
        aria-label="Close menu overlay"
      ></button>

      <!-- MENU CONTENT -->
      <div class="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6">

        <!-- CLOSE BUTTON -->
        <button
          type="button"
          (click)="closeMenu()"
          class="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-white/70 backdrop-blur-md text-gray-800 text-2xl shadow-md hover:bg-blue-50 hover:text-blue-600 transition"
          aria-label="Close menu"
        >
          ✕
        </button>

        <!-- LINKS -->
        <a routerLink="/" (click)="closeMenu()" class="text-2xl font-medium text-gray-800 hover:text-blue-600 mb-6 transition">
          Home
        </a>

        <a routerLink="/who-we-are" (click)="closeMenu()" class="text-2xl font-medium text-gray-800 hover:text-blue-600 mb-6 transition">
          About Us
        </a>

        <a routerLink="/pricing" (click)="closeMenu()" class="text-2xl font-medium text-gray-800 hover:text-blue-600 mb-6 transition">
          Pricing
        </a>

        <a routerLink="/contact-us" (click)="closeMenu()" class="text-2xl font-medium text-gray-800 hover:text-blue-600 mb-6 transition">
          Contact Us
        </a>

        <!-- CTA -->
        <button
          type="button"
          class="mt-8 bg-blue-600 text-white px-5 py-2 text-sm rounded-lg font-medium hover:bg-blue-700 transition"
          routerLink="/gap-check/intro"
          (click)="closeMenu()"
        >
          Get Free Gap Check
        </button>

      </div>
    </div>
  }

</nav>